export default {
  title: 'マーチャント管理',
  companyInfo: '企業情報',
  emailConfig: 'メール設定',
  smsConfig: 'SMS設定',
  i18nManagement: '多言語管理',
  paymentAuthConfig: '支払いと認証設定',
  systemSettings: 'システム設定',
  roleManagement: 'ロール管理',
  accountManagement: 'アカウント管理',
  operationLog: '操作ログ',
};
